import { useInputState } from './useInputState';
import { validateNameFormat, validateNameLength } from '../name';

const validations = [
  {
    validate: (value) => value && value.trim && !!value.trim(),
    errorMessage: 'lastNameRequiredError'
  },
  {
    validate: (value) => validateNameFormat(value),
    errorMessage: 'invalidLastName'
  },
  {
    validate: (value) => validateNameLength(value),
    errorMessage: 'invalidNameLength'
  }
];

export function useLastNameInputState(options) {
  return useInputState({
    initialValue: '',
    validations,
    ...(options || {})
  });
}
